<template>
  <div class="page-wrap">
    <div class="panel-card">

      <!-- Header -->
      <div class="panel-header">
        <div class="panel-header__icon"><i class="fa fa-briefcase"></i></div>
        <div class="panel-header__text">
          <div class="panel-header__title">Location Job Report</div>
          <div class="panel-header__sub">Mobile service transactions grouped by location and job</div>
        </div>
      </div>

      <!-- Filter toolbar -->
      <div class="filter-bar">
        <div class="filter-bar__row">
          <adv-search
            @search="advSearch"
            :is_date_range="true"
            :is_service="true"
            :is_status="true"
            :is_job_report="true"
            :is_location="true"
            :reportData="excelreports"
            :titleworksheet="titleworksheet"
            :json_fields="json_fields"
            :header="header"
            :report_name="'mobile_service_report.xls'"
            :export_inline="true"
          />
        </div>
      </div>

      <!-- Loading -->
      <div class="state-box" v-if="getLoadingData">
        <div class="state-spinner"></div>
        <span>Loading report data…</span>
      </div>

      <!-- Prompt -->
      <div class="state-box state-box--muted" v-else-if="load">
        <i class="fa fa-filter state-box__icon"></i>
        <div class="state-box__title">Select search criteria</div>
        <div class="state-box__sub">Use the filters above to generate a report</div>
      </div>

      <!-- Empty -->
      <div class="state-box state-box--muted" v-else-if="!load && reports.length === 0">
        <i class="fa fa-inbox state-box__icon"></i>
        <div class="state-box__title">No records found</div>
        <div class="state-box__sub">Try adjusting your filters</div>
      </div>

      <!-- Table -->
      <div class="table-wrap" v-if="reports.length > 0 && !getLoadingData">
        <table class="report-table">
          <thead>
            <tr>
              <th class="th-sm">#</th>
              <th class="th-loc" v-if="search.location === 'all'">Location</th>
              <th class="th-job">Job Title</th>
              <th class="th-name">Applicant</th>
              <th class="th-svc">Service</th>
              <th class="th-status">Service Status</th>
              <th class="th-status">Payment</th>
              <th class="th-date">Date</th>
              <th class="th-num">Commission</th>
              <th class="th-num">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in reports" :key="index">
              <td class="td-sm">{{ index + 1 }}</td>
              <td v-if="search.location === 'all'" class="td-loc">{{ item.location_name }}</td>
              <td class="td-job">{{ item.job_title }}</td>
              <td class="td-name">{{ item.applicant }}</td>
              <td>{{ item.service }}</td>
              <td>
                <span class="status-chip" :class="serviceStatusClass(item.service_status)">
                  {{ item.service_status }}
                </span>
              </td>
              <td>
                <span class="status-chip" :class="paymentStatusClass(item.payment_status)">
                  {{ item.payment_status }}
                </span>
              </td>
              <td class="td-date">
                {{ item.schedule_date ? dateFormat(item.schedule_date) : 'N/A' }}
              </td>
              <td class="td-num">$ {{ item.commission | toFixedTwoDigit }}</td>
              <td class="td-num">$ {{ item.amount | toFixedTwoDigit }}</td>
            </tr>

            <!-- Grand total -->
            <tr class="grand-total-row">
              <td :colspan="search.location === 'all' ? 8 : 7" class="grand-total-label">Grand Total</td>
              <td class="td-num grand-total-val">$ {{ total_commission | toFixedTwoDigit }}</td>
              <td class="td-num grand-total-val">$ {{ grand_total | toFixedTwoDigit }}</td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</template>

<script>
import {
  FETCH_CLIENTS,
  FETCH_SERVICES,
  FETCH_LOCATION_JOB_WISE_REPORT,
} from "@/core/services/store/actions.type";
import { SET_BREADCRUMB } from "@/core/services/store/mutations.type";
import { mapGetters } from "vuex";
import AdvSearch from "@/includes/search/AdvSearch";

export default {
  components: { AdvSearch },
  computed: {
    ...mapGetters(["currentUser", "getClients", "getServices", "getCompanies", "getSearchDate"]),
    grand_total() {
      return this.reports.reduce((sum, e) => sum + (e.amount || 0), 0);
    },
    total_commission() {
      return this.reports.reduce((sum, e) => sum + (e.commission || 0), 0);
    },
  },
  filters: {
    toFixedTwoDigit(amount) {
      return parseFloat(amount).toFixed(2);
    },
  },
  data() {
    return {
      search: {
        service: "all",
        company: "all",
        date_from: "",
        date_to: "",
        service_status: "all",
        payment_status: "all",
        location: "all",
        search_text: "",
      },
      getLoadingData: false,
      reports: [],
      header: [],
      load: true,
      excelreports: [],
      titleworksheet: "",
      json_fields: {
        "Location": "location_name",
        "Job Title": "job_title",
        "Applicant Name": "applicant",
        Service: "service",
        "Service Status": "service_status",
        "Payment Status": "payment_status",
        "Scheduled Date": "schedule_date",
        Commission: "commission",
        Amount: "amount",
      },
      breadCrumbs: [
        { id: 1, title: "Dashboard",           route: "client.dashboard" },
        { id: 2, title: "Report",              route: "" },
        { id: 3, title: "Location Job Report", route: "" },
      ],
    };
  },
  mounted() {
    this.$store.dispatch(FETCH_CLIENTS);
    this.$store.commit(SET_BREADCRUMB, this.breadCrumbs);
    this.$store.dispatch(FETCH_SERVICES, this.currentUser.u.is_client ? "self" : "all");
  },
  methods: {
    dateFormat(date) {
      if (!date) return "N/A";
      const d = new Date(date);
      return isNaN(d) ? date : d.toLocaleDateString("en-US", { month: "2-digit", day: "2-digit", year: "numeric" });
    },
    serviceStatusClass(status) {
      if (!status) return "chip--grey";
      const s = status.toLowerCase();
      if (s === "completed" || s === "c") return "chip--green";
      if (s === "pending"   || s === "p") return "chip--orange";
      if (s === "cancel"    || s === "canceled") return "chip--red";
      return "chip--grey";
    },
    paymentStatusClass(status) {
      if (!status) return "chip--grey";
      const s = status.toLowerCase();
      if (s === "paid"   || s === "p") return "chip--green";
      if (s === "unpaid" || s === "u") return "chip--orange";
      return "chip--grey";
    },
    advSearch(value) {
      this.getLoadingData = true;
      this.load = false;
      const { header, search, footer } = value;
      this.header = header;
      this.search = { ...search };
      this.tablereset();
      this.$store
        .dispatch(FETCH_LOCATION_JOB_WISE_REPORT, search)
        .then((res) => {
          this.getLoadingData = false;
          this.reports = res.data;
          this.titleworksheet = search.date_from + " - " + search.date_to;
          this.excelreports = [...res.data];
          if (res.data.length > 0) {
            const total      = res.data.reduce((s, e) => s + e.amount, 0);
            const commission = res.data.reduce((s, e) => s + e.commission, 0);
            this.excelreports.push({ schedule_date: "Grand Total", service: "", job_title: "", applicant: "", location_name: "", service_status: "", payment_status: "", amount: total, commission });
          }
          this.excelreports.push({ schedule_date: "", service: "", job_title: "", applicant: "", location_name: "", service_status: "", payment_status: "", amount: footer[1], commission: footer[0] });
        })
        .catch((err) => {
          this.getLoadingData = false;
          this.msg = err.error;
        });
    },
    tablereset() {
      if (this.search.location !== "all") {
        this.json_fields = { "Job Title": "job_title", "Applicant Name": "applicant", Service: "service", "Service Status": "service_status", "Payment Status": "payment_status", "Scheduled Date": "schedule_date", Commission: "commission", Amount: "amount" };
      } else {
        this.json_fields = { Location: "location_name", "Job Title": "job_title", "Applicant Name": "applicant", Service: "service", "Service Status": "service_status", "Payment Status": "payment_status", "Scheduled Date": "schedule_date", Commission: "commission", Amount: "amount" };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$font:   'Segoe UI', sans-serif;
$blue:   #389ad4;
$dark:   #0d1b3e;
$green:  #276749;
$border: #dde2ec;

@keyframes spin { to { transform: rotate(360deg); } }

.page-wrap {
  padding: 12px;
  font-family: $font;
}

/* ── panel card ── */
.panel-card {
  background: #fff;
  border: 1px solid $border;
  border-radius: 16px;
  overflow: clip;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}

/* ── header ── */
.panel-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px 24px;
  border-bottom: 1px solid $border;
  background: linear-gradient(135deg, #f8faff 0%, #f0f5ff 100%);

  &__icon {
    width: 48px; height: 48px; border-radius: 12px;
    background: linear-gradient(135deg, $blue, #2277aa);
    display: flex; align-items: center; justify-content: center;
    color: #fff; font-size: 18px; flex-shrink: 0;
  }

  &__text { flex: 1; }
  &__title { font-size: 16px; font-weight: 700; color: $dark; line-height: 1.2; }
  &__sub   { font-size: 12px; color: #7a8499; margin-top: 3px; }
}

/* ── filter bar ── */
.filter-bar {
  border-bottom: 1px solid $border;
  background: #fafbfd;
  position: sticky;
  top: 0;
  z-index: 20;

  &__row { padding: 8px 16px 12px; }
}

/* ── state boxes ── */
.state-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 56px 24px;
  gap: 8px;
  font-size: 13px;
  color: #7a8499;

  &--muted .state-box__icon { color: #c5d0e0; }
  &__icon  { font-size: 36px; margin-bottom: 4px; }
  &__title { font-size: 15px; font-weight: 600; color: $dark; }
  &__sub   { font-size: 13px; color: #7a8499; }
}

.state-spinner {
  width: 32px; height: 32px;
  border: 3px solid #c5d8f5;
  border-top-color: $blue;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
  margin-bottom: 8px;
}

/* ── table ── */
.table-wrap {
  overflow-x: auto;
  overflow-y: auto;
  max-height: calc(100vh - 220px);
  padding: 0 24px 24px;
}

.report-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  color: $dark;

  th {
    position: sticky;
    top: 0;
    z-index: 1;
    padding: 10px 12px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #7a8499;
    border-bottom: 2px solid $border;
    white-space: nowrap;
    background: #fafbfd;
  }

  .th-sm     { width: 44px;  text-align: center; }
  .th-loc    { width: 14%; }
  .th-job    { width: 16%; }
  .th-name   { width: 14%; }
  .th-svc    { width: 14%; }
  .th-status { width: 110px; }
  .th-date   { width: 110px; white-space: nowrap; }
  .th-num    { width: 110px; text-align: right; white-space: nowrap; }

  td {
    padding: 10px 12px;
    border-bottom: 1px solid #f0f2f8;
    vertical-align: middle;
  }

  tr:hover td { background: #f8fbff; }
  tr:last-child td { border-bottom: none; }

  .td-sm   { text-align: center; color: #a0aab8; font-size: 12px; }
  .td-loc  { font-size: 12.5px; color: #5a6278; }
  .td-job  { font-weight: 500; }
  .td-name { font-size: 13px; }
  .td-date { white-space: nowrap; font-size: 12px; color: #5a6278; }
  .td-num  { text-align: right; font-variant-numeric: tabular-nums; white-space: nowrap; min-width: 110px; }
}

/* ── status chips ── */
.status-chip {
  display: inline-block;
  padding: 2px 9px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  text-transform: capitalize;
  background: #f0f3fa;
  color: #7a8499;

  &.chip--green  { background: rgba(39,103,73,0.1);  color: $green; }
  &.chip--orange { background: rgba(217,119,6,0.1);  color: #92520a; }
  &.chip--red    { background: rgba(180,35,24,0.1);  color: #b42318; }
  &.chip--grey   { background: #f0f3fa; color: #7a8499; }
}

/* ── grand total row ── */
.grand-total-row td {
  background: #f4f6fb !important;
  border-top: 2px solid $border;
  border-bottom: 2px solid $border;
}

.grand-total-label {
  text-align: right;
  font-size: 12px;
  font-weight: 700;
  color: $dark;
  padding-right: 16px !important;
}

.grand-total-val {
  font-size: 13px;
  font-weight: 700;
  color: $dark;
  font-variant-numeric: tabular-nums;
}
</style>
